import React from "react";

export default function Spinner({ size = "md", className = "" }) {
  const sizes = { sm: "h-4 w-4", md: "h-6 w-6", lg: "h-10 w-10" };
  return (
    <svg
      className={`animate-spin ${sizes[size]} text-brand-400 ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

export function SkeletonCard() {
  return (
    <div className="card space-y-4">
      <div className="skeleton h-5 w-2/3">&nbsp;</div>
      <div className="skeleton h-4 w-1/2">&nbsp;</div>
      <div className="skeleton h-4 w-3/4">&nbsp;</div>
    </div>
  );
}
